import { OrganizationName } from 'constants/organization/types';

export const getAppLogoAlt = (appName: string | null) => `${appName || 'yubi'}-logo`;
export const shouldHideSignUp = (organization: OrganizationName) => {
    return [OrganizationName.COLLECTIONS].includes(organization);
};

export const getSetPasswordParams = (
    userId: string,
    token: string,
    organization: OrganizationName | null
) => {
    if (organization === OrganizationName.COLLECTIONS)
        return `/set-password?&u=${userId}&t=${token}&app_name=${organization}`;
    return `/set-password?&u=${userId}&t=${token}`;
};

export const getForgotPasswordLink = (organization: OrganizationName | null) => {
    if (organization === OrganizationName.COLLECTIONS)
        return `/forgot-password&app_name=${organization}`;
    return '/forgot-password';
};
